import { useFeatureFlags } from "src/contexts/FeatureFlagProvider";

type UseMaxClipsArgs = {
  clipCount: number;
};

type UseMaxClipsResult = {
  isMaxed: boolean;
  max: number;
  maxFormatted: string;
};

export function useMaxClips({ clipCount }: UseMaxClipsArgs): UseMaxClipsResult {
  const { featureFlags, featureConfig } = useFeatureFlags();

  const max = featureConfig.render.v3.maxSegmentCountToRender;
  const isMaxed = featureFlags.v3Renderer && clipCount > max;

  return {
    isMaxed,
    max,
    maxFormatted: max.toLocaleString("en-US"),
  };
}
